import { createStore } from 'vuex'

export const kcStore = createStore({
    state: {
        account: null,
        stundenplan: {
            stunden: [
                { stunde: 1, uhrzeit: '08:10' },
                { stunde: 2, uhrzeit: '08:55' },
                { stunde: 3, uhrzeit: '10:05' },
                { stunde: 4, uhrzeit: '10:50' },
                { stunde: 5, uhrzeit: '12:00' },
                { stunde: 6, uhrzeit: '12:45' },
            ],
            tage: [
                {
                    tag: 'Mo',
                    stunden: [
                        { stunde: 1, fach: 'Englisch' },
                        { stunde: 2, fach: 'Englisch' },
                        { stunde: 3, fach: 'Mathe' },
                        { stunde: 4, fach: 'Mathe' },
                        { stunde: 5, fach: 'Musik' },
                        { stunde: 6, fach: 'Musik' },
                    ]
                },
                {
                    tag: 'Di',
                    stunden: [
                        { stunde: 1, fach: 'Deutsch' },
                        { stunde: 2, fach: 'Deutsch' },
                        { stunde: 3, fach: 'Biologie' },
                        { stunde: 4, fach: 'Biologie' },
                        { stunde: 5, fach: 'Mathe' },
                        { stunde: 6, fach: 'Mathe' },
                    ]
                },
                {
                    tag: 'Mi',
                    stunden: [
                        { stunde: 1, fach: 'Sport' },
                        { stunde: 2, fach: 'Sport' },
                        { stunde: 3, fach: 'Deutsch' },
                        { stunde: 4, fach: 'Deutsch' },
                        { stunde: 5, fach: 'Religion' },
                        { stunde: 6, fach: 'Religion' },
                    ]
                },
                {
                    tag: 'Do',
                    stunden: [
                        { stunde: 1, fach: 'Englisch' },
                        { stunde: 2, fach: 'Englisch' },
                        { stunde: 3, fach: 'Mathe', woche: 'A' },
                        { stunde: 3, fach: 'Informatik', woche: 'B' },
                        { stunde: 4, fach: 'Mathe', woche: 'A' },
                        { stunde: 4, fach: 'Informatik', woche: 'B' },
                        { stunde: 5, fach: 'Sport' },
                        { stunde: 6, fach: 'Sport' },
                    ]
                },
                {
                    tag: 'Fr',
                    stunden: [
                        { stunde: 1, fach: 'Kunst' },
                        { stunde: 2, fach: 'Kunst' },
                        { stunde: 3, fach: 'Deutsch', woche: 'A' },
                        { stunde: 3, fach: 'Englisch', woche: 'B' },
                        { stunde: 4, fach: 'Deutsch', woche: 'A' },
                        { stunde: 4, fach: 'Englisch', woche: 'B' },
                        { stunde: 5, fach: 'Erdkunde' },
                        { stunde: 6, fach: 'Erdkunde' },
                    ]
                }                                                               
            ]
        }
    },
    getters: {   
    },
    mutations: {
    },
    actions: {
    },
    // Sub modules
    modules: {
    }
});